import { CalendarClock, Tag, Zap } from "lucide-react";
import AgendarPicker from "../sms/AgendarPicker";

/**
 * Passo 1: nome da campanha (como ela aparece nos relatórios) e quando enviar
 * — agora ou agendado, com o mesmo seletor do SMS e a mesma janela (9h–22h).
 */
export default function CampanhaTopo({ nome, setNome, quando, setQuando, agenda, setAgenda }) {
  const set = (k) => (v) => setAgenda({ ...agenda, [k]: v });
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
      <div>
        <label className="text-sm font-semibold flex items-center gap-2"><Tag className="h-4 w-4 text-primary" /> Nome da campanha</label>
        <input value={nome} onChange={(e) => setNome(e.target.value)} maxLength={80} autoFocus
          placeholder="Ex.: Promoção de terça" className="mt-2 w-full rounded-lg border bg-background px-3 py-2 text-sm" />
        <p className="mt-1 text-[11px] text-muted-foreground">É como ela aparece nos relatórios, com os cliques no link e os pedidos.</p>
      </div>
      <div>
        <label className="text-sm font-semibold flex items-center gap-2"><CalendarClock className="h-4 w-4 text-primary" /> Quando enviar</label>
        <div className="mt-2 flex flex-wrap items-center gap-2">
          <div className="flex gap-1 rounded-full border p-0.5">
            {[["agora", "Agora", Zap], ["agendar", "Agendar", CalendarClock]].map(([k, rotulo, Icone]) => (
              <button key={k} type="button" onClick={() => setQuando(k)}
                className={`inline-flex items-center gap-1 rounded-full px-3 py-1 text-xs font-medium transition-colors ${
                  quando === k ? "bg-primary text-primary-foreground" : "hover:bg-muted"}`}>
                <Icone className="h-3 w-3" /> {rotulo}
              </button>
            ))}
          </div>
          {quando === "agendar" && (
            <AgendarPicker dataAg={agenda.data} setDataAg={set("data")} horaAg={agenda.hora} setHoraAg={set("hora")}
              minAg={agenda.min} setMinAg={set("min")} />
          )}
        </div>
        {quando === "agendar" && (
          <p className="mt-1.5 text-[10px] text-muted-foreground">Só entre 9h e 22h, como no SMS. Até a hora marcada dá pra cancelar e o valor volta.</p>
        )}
      </div>
    </div>
  );
}
